export default __webpack_public_path__ + "static/media/table.png?.a66f20f1";